// Generated by scripts/seed-from-export.mjs; do not edit.
import type { PageBlock } from '../lib/types';

export const wpPages: Record<string, { title: string; blocks: PageBlock[]; heroImageId: string | null }> = {
  "home": {
    "title": "Home",
    "blocks": [
      {
        "id": "b1",
        "type": "heading",
        "text": "Celebrate Community with Exclusive Events",
        "level": 2
      },
      {
        "id": "b2",
        "type": "image",
        "mediaId": "wp-113",
        "altText": "",
        "caption": ""
      },
      {
        "id": "b3",
        "type": "paragraph",
        "text": "Discover a vibrant social scene where curated events foster lasting friendships and exclusive networking opportunities designed to enrich your lifestyle."
      },
      {
        "id": "b4",
        "type": "image",
        "mediaId": "wp-114",
        "altText": "",
        "caption": ""
      },
      {
        "id": "b5",
        "type": "heading",
        "text": "Experience Exclusive Moments at Casa Borinquen",
        "level": 3
      },
      {
        "id": "b6",
        "type": "paragraph",
        "text": "Discover upcoming socials and unique events designed to connect and inspire our vibrant community."
      },
      {
        "id": "b7",
        "type": "image",
        "mediaId": "wp-115",
        "altText": "",
        "caption": ""
      },
      {
        "id": "b8",
        "type": "heading",
        "text": "Summer Salsa Night",
        "level": 3
      },
      {
        "id": "b9",
        "type": "paragraph",
        "text": "Jul 24, 2026"
      },
      {
        "id": "b10",
        "type": "paragraph",
        "text": "Join us for an energetic evening of salsa, live music, and dance lessons."
      },
      {
        "id": "b11",
        "type": "image",
        "mediaId": "wp-102",
        "altText": "",
        "caption": ""
      },
      {
        "id": "b12",
        "type": "heading",
        "text": "Wine Tasting & Jazz Evening",
        "level": 3
      },
      {
        "id": "b13",
        "type": "paragraph",
        "text": "Aug 23, 2026"
      },
      {
        "id": "b14",
        "type": "paragraph",
        "text": "Savor fine wines paired with smooth jazz in an intimate setting."
      },
      {
        "id": "b15",
        "type": "image",
        "mediaId": "wp-102",
        "altText": "",
        "caption": ""
      },
      {
        "id": "b16",
        "type": "heading",
        "text": "Autumn Harvest Gala",
        "level": 3
      },
      {
        "id": "b17",
        "type": "paragraph",
        "text": "Oct 14, 2026"
      },
      {
        "id": "b18",
        "type": "paragraph",
        "text": "Celebrate the season with gourmet dishes, live entertainment, and great company."
      },
      {
        "id": "b19",
        "type": "heading",
        "text": "Experience Exclusive Events and Social Connections",
        "level": 2
      },
      {
        "id": "b20",
        "type": "paragraph",
        "text": "Discover Casa Borinquen’s exclusive events and unique social gatherings designed for our members."
      },
      {
        "id": "b21",
        "type": "heading",
        "text": "Blog",
        "level": 2
      },
      {
        "id": "b22",
        "type": "paragraph",
        "text": "Explore our latest events and exclusive social gatherings designed to connect and inspire our members."
      },
      {
        "id": "b23",
        "type": "heading",
        "text": "Experience the Vibrant Social Scene at Casa Borinquen",
        "level": 2
      },
      {
        "id": "b24",
        "type": "paragraph",
        "text": "Connect with Casa Borinquen through our exclusive club address, dedicated phone line, and direct email to stay informed about upcoming events and membership opportunities."
      }
    ],
    "heroImageId": null
  },
  "services": {
    "title": "Services",
    "blocks": [
      {
        "id": "b1",
        "type": "heading",
        "text": "Service Overview",
        "level": 2
      },
      {
        "id": "b2",
        "type": "paragraph",
        "text": "Discover how Casa Borinquen crafts unforgettable social events that connect members through unique cultural and leisure opportunities."
      },
      {
        "id": "b3",
        "type": "heading",
        "text": "Curated Social Gatherings",
        "level": 3
      },
      {
        "id": "b4",
        "type": "paragraph",
        "text": "Enjoy intimate and lively events designed to foster community and create lasting memories for all attendees."
      },
      {
        "id": "b5",
        "type": "heading",
        "text": "Member-Only Benefits",
        "level": 3
      },
      {
        "id": "b6",
        "type": "paragraph",
        "text": "Access exclusive perks and special offers that enhance your experience as part of our vibrant social club."
      },
      {
        "id": "b7",
        "type": "image",
        "mediaId": "wp-111",
        "altText": "",
        "caption": ""
      },
      {
        "id": "b8",
        "type": "heading",
        "text": "Tropical Nights Social Gala",
        "level": 2
      },
      {
        "id": "b9",
        "type": "paragraph",
        "text": "Date:"
      },
      {
        "id": "b10",
        "type": "paragraph",
        "text": "Location:"
      },
      {
        "id": "b11",
        "type": "paragraph",
        "text": "Experience an unforgettable night at Casa Borinquen with vibrant music, delicious cuisine, and meaningful connections that celebrate culture and community spirit."
      },
      {
        "id": "b12",
        "type": "image",
        "mediaId": "wp-98",
        "altText": "",
        "caption": ""
      }
    ],
    "heroImageId": null
  },
  "gallery": {
    "title": "Gallery",
    "blocks": [
      {
        "id": "b1",
        "type": "heading",
        "text": "Experience the Heart of Casa Borinquen",
        "level": 2
      },
      {
        "id": "b2",
        "type": "paragraph",
        "text": "Explore a vibrant gallery capturing the spirit and excitement of our exclusive events."
      },
      {
        "id": "b3",
        "type": "image",
        "mediaId": "wp-104",
        "altText": "",
        "caption": ""
      },
      {
        "id": "b4",
        "type": "image",
        "mediaId": "wp-105",
        "altText": "",
        "caption": ""
      },
      {
        "id": "b5",
        "type": "image",
        "mediaId": "wp-106",
        "altText": "",
        "caption": ""
      },
      {
        "id": "b6",
        "type": "image",
        "mediaId": "wp-107",
        "altText": "",
        "caption": ""
      },
      {
        "id": "b7",
        "type": "image",
        "mediaId": "wp-108",
        "altText": "",
        "caption": ""
      },
      {
        "id": "b8",
        "type": "image",
        "mediaId": "wp-109",
        "altText": "",
        "caption": ""
      },
      {
        "id": "b9",
        "type": "heading",
        "text": "Casa Borinquen Summer Fest",
        "level": 2
      },
      {
        "id": "b10",
        "type": "paragraph",
        "text": "Date:"
      },
      {
        "id": "b11",
        "type": "paragraph",
        "text": "Location:"
      },
      {
        "id": "b12",
        "type": "paragraph",
        "text": "Experience an exclusive night at Casa Borinquen filled with vibrant music, exquisite cuisine, and unforgettable connections. Celebrate culture and community in a setting designed for social engagement and lasting memories."
      },
      {
        "id": "b13",
        "type": "image",
        "mediaId": "wp-98",
        "altText": "",
        "caption": ""
      },
      {
        "id": "b14",
        "type": "heading",
        "text": "Experience Vibrant Social Moments",
        "level": 2
      }
    ],
    "heroImageId": null
  },
  "contact": {
    "title": "Contact",
    "blocks": [
      {
        "id": "b1",
        "type": "heading",
        "text": "Experience Memorable Moments at Casa Borinquen",
        "level": 2
      },
      {
        "id": "b2",
        "type": "paragraph",
        "text": "Find our location, contact number, and email here for seamless connection."
      },
      {
        "id": "b3",
        "type": "image",
        "mediaId": "wp-100",
        "altText": "",
        "caption": ""
      },
      {
        "id": "b4",
        "type": "paragraph",
        "text": "Reach out to us for all your event and membership inquiries."
      },
      {
        "id": "b5",
        "type": "paragraph",
        "text": "188 Hood Avenue, Suite 4B"
      },
      {
        "id": "b6",
        "type": "paragraph",
        "text": "230 Pine Street, Loft 3"
      },
      {
        "id": "b7",
        "type": "paragraph",
        "text": "+1-305-555-1234"
      },
      {
        "id": "b8",
        "type": "paragraph",
        "text": "contact@casaborinquen.com"
      },
      {
        "id": "b9",
        "type": "image",
        "mediaId": "wp-102",
        "altText": "",
        "caption": ""
      }
    ],
    "heroImageId": null
  },
  "about": {
    "title": "About",
    "blocks": [
      {
        "id": "b1",
        "type": "image",
        "mediaId": "wp-93",
        "altText": "",
        "caption": ""
      },
      {
        "id": "b2",
        "type": "heading",
        "text": "Discover Unforgettable Moments at Casa Borinquen",
        "level": 2
      },
      {
        "id": "b3",
        "type": "paragraph",
        "text": "Casa Borinquen is dedicated to creating a vibrant community through exclusive events and social gatherings. Our commitment to fostering connection, celebration, and cultural richness defines our club’s spirit and vision for lasting member experiences."
      },
      {
        "id": "b4",
        "type": "heading",
        "text": "Where Connections and Celebration Meet",
        "level": 3
      },
      {
        "id": "b5",
        "type": "paragraph",
        "text": "Discover the passionate experts who craft unforgettable experiences at Casa Borinquen."
      },
      {
        "id": "b6",
        "type": "image",
        "mediaId": "wp-94",
        "altText": "",
        "caption": ""
      },
      {
        "id": "b7",
        "type": "heading",
        "text": "Isabela Rivera",
        "level": 3
      },
      {
        "id": "b8",
        "type": "paragraph",
        "text": "Event Coordinator"
      },
      {
        "id": "b9",
        "type": "image",
        "mediaId": "wp-95",
        "altText": "",
        "caption": ""
      },
      {
        "id": "b10",
        "type": "heading",
        "text": "Javier Morales",
        "level": 3
      },
      {
        "id": "b11",
        "type": "paragraph",
        "text": "Social Engagement Manager"
      },
      {
        "id": "b12",
        "type": "image",
        "mediaId": "wp-96",
        "altText": "",
        "caption": ""
      },
      {
        "id": "b13",
        "type": "heading",
        "text": "Camila Torres",
        "level": 3
      },
      {
        "id": "b14",
        "type": "paragraph",
        "text": "Membership Director"
      },
      {
        "id": "b15",
        "type": "image",
        "mediaId": "wp-97",
        "altText": "",
        "caption": ""
      },
      {
        "id": "b16",
        "type": "heading",
        "text": "Luis Delgado",
        "level": 3
      },
      {
        "id": "b17",
        "type": "paragraph",
        "text": "Venue Manager"
      },
      {
        "id": "b18",
        "type": "heading",
        "text": "Experience the vibrant rhythms of our exclusive salsa night.",
        "level": 2
      },
      {
        "id": "b19",
        "type": "paragraph",
        "text": "When:"
      },
      {
        "id": "b20",
        "type": "paragraph",
        "text": "Where:"
      },
      {
        "id": "b21",
        "type": "paragraph",
        "text": "Celebrate culture and connection at Casa Borinquen’s exclusive events. Enjoy unique social gatherings, vibrant music, and unforgettable moments designed to bring our community closer."
      },
      {
        "id": "b22",
        "type": "image",
        "mediaId": "wp-98",
        "altText": "",
        "caption": ""
      }
    ],
    "heroImageId": null
  }
};
